export const ACTIONS = {
  SEND_CLASS_CHAT_MESSAGE: 'SEND_CLASS_CHAT_MESSAGE',
  RECEIVE_CLASS_CHAT_MESSAGE: 'RECEIVE_CLASS_CHAT_MESSAGE',
};

export const sendClassChatMessage = (channel, message, meta) => ({
  type: ACTIONS.SEND_CLASS_CHAT_MESSAGE,
  payload: {
    channel,
    message,
    meta,
  },
});

export const receiveClassChatMessage = (message, meta) => ({
  type: ACTIONS.RECEIVE_CLASS_CHAT_MESSAGE,
  payload: {
    message,
    meta,
  },
});
